import { FC } from 'react'
import { graphql } from 'relay-runtime'
import { useFragment } from 'react-relay/hooks'
import { RelatedPosts_post$key } from './__generated__/RelatedPosts_post.graphql'
import { PostCard } from '@lifedot/components/PostCard'
import Link from 'next/link'
import { router } from '@lifedot/router'
import { css } from '@emotion/react'
import { typography } from '@lifedot/styles/typography'
import { mq } from '@lifedot/styles/mediaQuery'

const styles = {
  root: {
    [mq('sp')]: {
      padding: '0 8px'
    }
  },
  wrapper: css({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  }),
  item: css({
    width: 'calc(50% - 4px)',
    textDecoration: 'none',
    marginTop: 8,
    [mq('sp')]: {
      width: '100%'
    }
  })
}

interface RelatedPostsProps {
  post: RelatedPosts_post$key
}

export const RelatedPosts: FC<RelatedPostsProps> = ({ post }) => {
  const { related_posts } = useFragment(fragment, post)

  if (related_posts.items.length < 1) return null

  return (
    <div css={styles.root}>
      <h2 css={typography.headingS}>関連記事</h2>
      <div css={styles.wrapper}>
        {related_posts.items.map(({ slug, image, h1 }) => (
          <Link key={slug} href={router.post(slug)} passHref prefetch={false}>
            <a css={styles.item}>
              <PostCard
                title={h1}
                thumbnailUrl={image?.url}
                thumbnailAlt={image?.alt}
                horizontal
              />
            </a>
          </Link>
        ))}
      </div>
    </div>
  )
}

const fragment = graphql`
  fragment RelatedPosts_post on Post {
    related_posts(page: { from: 0, size: 20 }) {
      items {
        slug
        image {
          url
          alt
        }
        h1
      }
    }
  }
`
